import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'app/shared/services/api.service';
import { ro } from 'date-fns/locale';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-add',
  templateUrl: './add.component.html',
  styleUrls: ['./add.component.scss']
})
export class AddComponent implements OnInit {

  credentialsForm: FormGroup
  credentialsFormSubmitted: boolean = false;
  credent_model = {
      title: '',
      user_name: '',
      password: '',
      website_url: '',
      description: '',
      secutity_questions: [
        {
          questionId: '',
          answer: ''
        }
      ],
      passcode: '',
      experation_date: '',
      renewal_instructions: '',
      support_contact: '',
      primary_contact: '',
      notes: '',
      alote_dto: '',
      access_level: '',
      two_Factor_Authentication: ''
  }
  questions_data = []
  credential_id:any
  constructor(private formBuilder: FormBuilder, public apiService: ApiService,
    public toastr: ToastrService, private route: Router,private activatedroute:ActivatedRoute) { 
              this.activatedroute.paramMap.subscribe(params => { 
                    this.credential_id = params.get('id'); 
                });  
              }

  ngOnInit(): void {
    this.credentialsForm = this.formBuilder.group({
      title: ['', Validators.required],
      user_name: ['',Validators.required],
      password: ['',Validators.required],
      website_url: ['',],
      description: ['',],
      answer: ['',],
      passcode: ['',],
      experation_date: ['',],
      renewal_instructions: ['',],
      support_contact: ['',],
      primary_contact: ['',],
      notes: ['',],
      alote_dto: ['',],
      access_level: ['',],
      two_Factor_Authentication: ['',],
    })

    this.getAllQuestions()
    if (this.credential_id) {
      this.getCredntialByIdd(this.credential_id)
    }
  }
  get rf() {
    return this.credentialsForm.controls;
  }
  getAllQuestions() {
    this.apiService.getQuestionsList(1, 100).subscribe((res: any) => {
      this.questions_data = res?.data?.items
    })
  }
  getCredntialByIdd(id) {
    this.apiService.getCredentialById(id).subscribe((res: any) => {
      console.log(res)
      this.credent_model.title = res?.data?.title
      this.credent_model.user_name = res?.data?.user_name
      this.credent_model.password = res?.data?.password
      this.credent_model.website_url = res?.data?.website_url
      this.credent_model.description = res?.data?.description
      this.credent_model.passcode = res?.data?.passcode
      this.credent_model.experation_date = res?.data?.experation_date
      this.credent_model.renewal_instructions = res?.data?.renewal_instructions
      this.credent_model.support_contact = res?.data?.support_contact
      this.credent_model.primary_contact = res?.data?.primary_contact
      this.credent_model.access_level = res?.data?.access_level
      this.credent_model.secutity_questions[0].questionId = res?.data?.secutity_questions[0]._id
      this.credent_model.secutity_questions[0].answer = res?.data?.secutity_questions[0].answer
      this.credent_model.notes = res?.data?.notes
      this.credent_model.alote_dto = res?.data?.alote_dto
      this.credent_model.two_Factor_Authentication = res?.data?.two_Factor_Authentication
    })
  } 
  submit() {
    
    let body = {
        title: this.credentialsForm.value.title,
        user_name: this.credentialsForm.value.user_name,
        password: this.credentialsForm.value.password,
        website_url: this.credentialsForm.value.website_url,
        description: this.credentialsForm.value.description,
        secutity_questions: [
          {
            questionId: this.questions_data[0]?._id,
            answer: this.credentialsForm.value.answer
          }
        ],
        passcode: this.credentialsForm.value.passcode,
        experation_date: this.credentialsForm.value.experation_date,
        renewal_instructions: this.credentialsForm.value.renewal_instructions,
        support_contact: this.credentialsForm.value.support_contact,
        primary_contact: this.credentialsForm.value.primary_contact,
        notes: this.credentialsForm.value.notes,
        alote_dto: this.credentialsForm.value.alote_dto,
        access_level: this.credentialsForm.value.access_level,
        two_Factor_Authentication: this.credentialsForm.value.two_Factor_Authentication
    }
    console.log('val', body)

    if (!this.credential_id) {
        this.apiService.createCredential(body).subscribe((res: any) => {
        if (res.statusCode === 200) {
          this.toastr.success('created successfull')
          this.route.navigate(['/credentials/list'])
        }
        else this.toastr.error(res.error)
      })
    }
    else {
      if (this.credential_id) {
        this.apiService.updateCredential(this.credential_id,this.credent_model).subscribe((res: any) => {
        if (res.statusCode === 200) {
          this.toastr.success('update successfull')
          this.route.navigate(['/credentials/list'])
        }
        else this.toastr.error(res.error)
      })
    }
    }
    
    
  }
  back() {
    this.route.navigate(['/credentials/list'])
  }
}
